import type { AccountNode } from '../schemas';

export function flattenAccounts(nodes: AccountNode[] | undefined): AccountNode[] {
  if (!nodes) return [];
  const result: AccountNode[] = [];
  
  function recurse(n: AccountNode) {
    result.push(n);
    if (n.children) {
      (n.children as AccountNode[]).forEach(recurse);
    }
  }
  
  nodes.forEach(recurse);
  return result;
}